export default __webpack_public_path__ + "static/spinner3-b61948ff3396d9a690dde921f2721d74.gif";